module.exports = __webpack_public_path__ + "img/img_xhpj_ skill_brand@3x.f45e55f9.png";